import { Flame } from "lucide-react";

function Agree({ n, m, testid }) {
  if (!m || !n) return null;
  return <span data-testid={testid} className="block text-[8px] font-extrabold uppercase tracking-wide text-indigo-700">{n}/{m} AI agree</span>;
}

export function StrongPick({ guessing, testid }) {
  if (!guessing?.strong_ank && !guessing?.strong_jodi) return null;
  return (
    <div data-testid={`strong-pick-${testid}`} className="mx-auto mb-2 w-fit rounded-lg border-2 border-[color:var(--accent-crimson)] bg-gradient-to-r from-[#FFE9A8] to-[#F3C24B] px-3 py-1.5 text-center shadow-sm">
      <p className="flex items-center justify-center gap-1 text-[9px] font-extrabold uppercase tracking-wider text-[color:var(--accent-crimson)]">
        <Flame className="h-3 w-3" /> Strong Pick
      </p>
      <div className="flex items-center justify-center gap-3 font-mono font-extrabold text-[#20050B]">
        {guessing.strong_ank && (
          <span data-testid={`strong-ank-${testid}`} className="text-sm">Ank <span className="text-lg">{guessing.strong_ank}</span>
            <Agree n={guessing.strong_ank_agree} m={guessing.models_used} testid={`strong-ank-agree-${testid}`} />
          </span>
        )}
        {guessing.strong_jodi && (
          <span data-testid={`strong-jodi-${testid}`} className="text-sm">Jodi <span className="text-lg">{guessing.strong_jodi}</span>
            <Agree n={guessing.strong_jodi_agree} m={guessing.models_used} testid={`strong-jodi-agree-${testid}`} />
          </span>
        )}
      </div>
    </div>
  );
}

export const coverageLabel = (g) => (g?.strong_ank || g?.strong_jodi ? "Coverage · " : "");
